import React, { useState } from 'react';
import { Viewer } from '@toast-ui/react-editor';
import { Button } from 'react-bootstrap';
import { FaReply } from 'react-icons/fa';
import CommentForm from './CommentForm';

// 다이어리 보드와 동일한 색상 팔레트
const TAB_COLORS = [
    '#fff9c4', // Soft Yellow
    '#f8bbd0', // Soft Pink
    '#bbdefb', // Soft Blue
    '#c8e6c9', // Soft Green
    '#e1bee7', // Soft Purple
    '#fff3e0'  // Soft Orange/Cream
];

const getTabColor = (id) => {
    const idNum = typeof id === 'string'
        ? id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
        : id;
    return TAB_COLORS[idNum % TAB_COLORS.length];
};

const CommentItem = ({ comment, childrenComments = [], onReplySuccess, depth = 0 }) => {
    const [isReplying, setIsReplying] = useState(false);
    const tabColor = getTabColor(comment.json.id);

    return (
        <div className="comment-item-container" style={{ marginLeft: depth > 0 ? '20px' : '0' }}>
            <div className="comment-post-it d-flex mb-3">
                {/* 인덱스 탭 (손잡이) */}
                <div
                    className="comment-tab"
                    style={{
                        backgroundColor: tabColor,
                        width: '20px',
                        minHeight: '100%',
                        borderRadius: '4px 0 0 4px',
                        boxShadow: '-2px 2px 5px rgba(0,0,0,0.1)'
                    }}
                />

                {/* 댓글 내용 영역 */}
                <div className="comment-content-wrapper flex-grow-1 p-3 bg-white border border-start-0 rounded-end shadow-sm position-relative">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold text-dark small">
                            {comment.json.nickname || "익명"}
                        </span>
                        <span className="text-muted small">
                            {comment.json.created_at?.substring(0, 10)}
                        </span>
                    </div>

                    <div className="toastui-editor-contents" style={{ fontSize: '14px' }}>
                        <Viewer initialValue={comment.json.content} />
                    </div>

                    {/* 답글 달기 버튼 */}
                    <div className="d-flex justify-content-end mt-2">
                        <Button
                            variant="link"
                            className="text-decoration-none text-muted p-0 d-flex align-items-center gap-1"
                            style={{ fontSize: '0.85rem' }}
                            onClick={() => setIsReplying(!isReplying)}
                        >
                            <FaReply /> 답글
                        </Button>
                    </div>

                    {/* 답글 작성 폼 */}
                    {isReplying && (
                        <div className="mt-3 border-top pt-3">
                            <CommentForm
                                postId={comment.json.post_id}
                                parentId={comment.json.id}
                                autoFocus={true}
                                onSuccess={() => {
                                    setIsReplying(false);
                                    if (onReplySuccess) onReplySuccess();
                                }}
                                onCancel={() => setIsReplying(false)}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* 대댓글 재귀 렌더링 */}
            {childrenComments.length > 0 && (
                <div className="children-comments">
                    {childrenComments.map(child => (
                        <CommentItem
                            key={child.json.id}
                            comment={child}
                            childrenComments={child.children || []} // 부모 컴포넌트에서 트리 구조를 만들어 넘겨준다고 가정
                            onReplySuccess={onReplySuccess}
                            depth={depth + 1}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CommentItem;
